import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import classes from "./RichTextContent.module.scss";

export interface RichTextContentProps {
  title?: string;
  content: string;
}

export default function RichTextContent(props: RichTextContentProps) {
  const { title, content } = props;
  return (
    <section className="section">
      <div className={`${classes["text-content"]}`}>
        <h2>{title}</h2>
        <div className={classes["text-body"]}>
          <CmsTextEditorContent content={content} />
        </div>
      </div>
    </section>
  );
}
